import React, { useState } from "react";
import Input from "../../containers/Input";

const AddProductToSale = ({ updateProduct, onCancel }) => {
  const [barcode, setBarcode] = useState("");

  const handleAdd = () => {
    updateProduct(barcode.trim(), true);
    setBarcode("");
  };

  return (
    <div className="sale-inline-form">
      <div className="sale-inline-form__row">
        <Input
          ClassName="sale-inline-form__input"
          Type="text"
          Title="ברקוד מוצר"
          name="ProductMkt"
          Value={barcode}
          InputChange={(value) => setBarcode(value)}
        />
        <button
          type="button"
          className="sale-inline-form__submit"
          onClick={handleAdd}
        >
          הוסף מוצר
        </button>
        {onCancel ? (
          <button
            type="button"
            className="sale-inline-form__submit"
            onClick={onCancel}
          >
            ביטול
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default AddProductToSale;
